import { AllVehiclesListQuery } from "generated/graphql"
import { useSelector } from "react-redux"
import { ApplicationState } from "../index"
// import { ApplicationState } from "..";
export interface AllVehiclesFilter {
  departments: Array<any>
  vehicleTypes: Array<any>
  status: {
    AV: boolean
    NA: boolean
    BR: boolean
    OT: boolean
    RP: boolean
    [key: string]: boolean
  }
}
export interface AllVehiclesState {
  selectedDate: string
  search: string
  page: number
  vehicleOpen: any
  isBulkUpdateModalOpen: boolean
  isVehicleModalOpen: boolean
  selectedVehicle: AllVehiclesListQuery["allVehiclesDetail"] | any
  filter: AllVehiclesFilter
  [key: string]: any
}

export function useSelectedVehicles() {
  return useSelector<ApplicationState>(
    state => state.selector.vehicles.selected
  )
}
